'use strict';Object.defineProperty(exports,'__esModule',{value:!0}),exports.startTimestamp=void 0,exports.getTimestamp=getTimestamp;var _globals=require('./globals');function getTimestamp(){if(!_globals.isBrowser){var secondsAndNanoseconds=_globals.process.hrtime();return secondsAndNanoseconds[0]+secondsAndNanoseconds[1]/1e6}return _globals.window.performance?_globals.window.performance.now():Date.now()}var startTimestamp=exports.startTimestamp=getTimestamp();
//# sourceMappingURL=timestamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/lib/utils/timestamp.js
// module id = 733
// module chunks = 0